/**
 * ==========================================================================
 * LUGGAGE PAGES JAVASCRIPT - INTERACTIONS & ENHANCEMENTS
 * ==========================================================================
 * 
 * File: assets/js/luggage-pages.js
 * Compatible with Hello Theme and existing booking system
 */

// Wait for jQuery to be available
document.addEventListener('DOMContentLoaded', function() {
    // Check if jQuery is available, if not wait or use vanilla JS
    if (typeof jQuery !== 'undefined') {
        initLuggagePagesWithJQuery();
    } else {
        // jQuery not available, use vanilla JS approach
        initLuggagePagesVanilla();
    }
});

function initLuggagePagesWithJQuery() {
    jQuery(document).ready(function($) {
        'use strict';
        
        // Initialize all functionality (FAQ functionality handled by faq-universal.js)
        initSmoothScrolling($);
        initAnimationsOnScroll($);
        initCTAButtons($);
        initLocationCards($);
        enhanceBookingForm($);
        initPriceCalculator($);
        
        console.log('✅ Luggage Pages: JavaScript initialized (jQuery)');
    });
}

/**
 * Smooth scrolling for anchor links
 */
function initSmoothScrolling($) {
    $('a[href^="#"]').on('click', function(e) {
        const target = $(this.getAttribute('href'));
        
        if (target.length) {
            e.preventDefault();
            
            $('html, body').animate({
                scrollTop: target.offset().top - 80 // Account for fixed header
            }, 800, 'easeInOutCubic');
            
            // Update URL without jumping
            if (history.pushState) {
                history.pushState(null, null, this.getAttribute('href'));
            }
        }
    });
    
    // Add easing function if not present
    if (!$.easing.easeInOutCubic) {
        $.easing.easeInOutCubic = function(x, t, b, c, d) {
            if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
            return c / 2 * ((t -= 2) * t * t + 2) + b;
        };
    }
}

/**
 * Animations on scroll (Intersection Observer)
 */
function initAnimationsOnScroll($) {
        if ('IntersectionObserver' in window) {
            const observerOptions = {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px'
            };

            const observer = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        const $element = $(entry.target);
                        
                        // Add animation classes based on element type
                        if ($element.hasClass('step-item') || $element.hasClass('benefit-item')) {
                            $element.addClass('animate-fade-in-up');
                        } else if ($element.hasClass('location-card')) {
                            $element.addClass('animate-fade-in');
                        } else if ($element.hasClass('faq-item')) {
                            $element.addClass('animate-fade-in-up');
                        }
                        
                        // Unobserve after animation
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            // Observe elements
            $('.step-item, .benefit-item, .location-card, .faq-item').each(function() {
                observer.observe(this);
            });
        }
    }

/**
 * Enhanced CTA button interactions
 */
function initCTAButtons($) {
        $('.btn-primary, .btn-outline').on('mouseenter', function() {
            $(this).addClass('btn-hover');
        }).on('mouseleave', function() {
            $(this).removeClass('btn-hover');
        });

        // Add loading state for booking buttons
        $('.btn[href*="booking"]').on('click', function() {
            const $btn = $(this);
            const originalText = $btn.text();
            
            $btn.addClass('btn-loading')
                .html('<span class="btn-spinner"></span> Cargando...')
                .prop('disabled', true);
            
            // Reset after timeout (in case user comes back)
            setTimeout(function() {
                $btn.removeClass('btn-loading')
                    .text(originalText)
                    .prop('disabled', false);
            }, 5000);
        });
    }

/**
 * Location cards hover effects
 */
function initLocationCards($) {
        $('.location-card').on('mouseenter', function() {
            $(this).addClass('card-hover');
        }).on('mouseleave', function() {
            $(this).removeClass('card-hover');
        });

        // Track location card clicks for analytics
        $('.location-card .btn').on('click', function() {
            const locationName = $(this).closest('.location-card').find('h3').text();
            
            // Google Analytics event (if available)
            if (typeof gtag !== 'undefined') {
                gtag('event', 'location_card_click', {
                    'location_name': locationName,
                    'event_category': 'engagement'
                });
            }
            
            console.log('Location card clicked:', locationName);
        });
    }

/**
 * Form validation enhancement (if booking form is present)
 */
function enhanceBookingForm($) {
    const $form = $('#booking-form');
    if ($form.length) {
        // Add visual feedback for form interactions
        $form.find('input, select, textarea').on('focus', function() {
            $(this).closest('.form-group, label').addClass('field-focus');
        }).on('blur', function() {
            $(this).closest('.form-group, label').removeClass('field-focus');
        });
    }
}

/**
 * CSS Animations for luggage pages
 * These classes are added by JavaScript
 */
const luggageAnimationCSS = `
/* Animation classes added by JavaScript */
.animate-fade-in {
    animation: fadeIn 0.6s ease-out forwards;
}

.animate-fade-in-up {
    animation: fadeInUp 0.6s ease-out forwards;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Button loading state */
.btn-loading {
    pointer-events: none;
    opacity: 0.7;
    position: relative;
}

.btn-spinner {
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 2px solid transparent;
    border-top: 2px solid currentColor;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-right: 8px;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* FAQ styles removed - now handled by faq-universal.css */

/* Enhanced button hover states */
.btn-hover {
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.card-hover {
    z-index: 10;
}
`;

// Add animation CSS to head if not already present
if (document.querySelector && !document.querySelector('#luggage-animations')) {
    const style = document.createElement('style');
    style.id = 'luggage-animations';
    style.textContent = luggageAnimationCSS;
    document.head.appendChild(style);
}

/**
 * ==========================================================================
 * ADDITIONAL ENHANCEMENTS
 * ==========================================================================
 */

/**
 * Vanilla JavaScript fallback (when jQuery is not available)
 */
function initLuggagePagesVanilla() {
    // Basic animations without jQuery
    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-fade-in');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.1 });

        // Observe elements
        const elements = document.querySelectorAll('.step-item, .benefit-item, .location-card');
        elements.forEach(el => observer.observe(el));
    }
    
    console.log('✅ Luggage Pages: JavaScript initialized (Vanilla)');
}

/**
 * Price Calculator functionality
 */
function initPriceCalculator($) {
    const $serviceType = $('#service-type');
    const $bagCount = $('#bag-count');
    const $storageDays = $('#storage-days');
    const $storageGroup = $('.storage-only');
    const $calculatedPrice = $('#calculated-price');
    const $priceNote = $('#price-note');
    const $bookService = $('#book-service');
    
    function calculatePrice() {
        const serviceType = $serviceType.val();
        const bagCount = parseInt($bagCount.val()) || 1;
        const storageDays = parseInt($storageDays.val()) || 1;
        let totalPrice = 0;
        let noteText = '';
        let bookingUrl = '';
        
        if (serviceType === 'transfer') {
            // Transfer pricing logic
            if (bagCount === 1) {
                totalPrice = 24;
                noteText = 'Minimum service fee';
            } else if (bagCount === 2) {
                totalPrice = 24;
                noteText = '2nd bag FREE!';
            } else {
                totalPrice = 24 + ((bagCount - 2) * 12);
                noteText = `2nd bag FREE, ${bagCount - 2} additional bags`;
            }
            // URL dinámica se obtiene de PHP, fallback a barcelona
            bookingUrl = window.bagsandgoBookingUrl || '/barcelona/booking/';
        } else {
            // Storage pricing logic
            const minimumFee = 24;
            const dailyRate = 6;
            const storageTotal = bagCount * dailyRate * storageDays;
            
            totalPrice = Math.max(minimumFee, storageTotal);
            
            if (totalPrice === minimumFee && storageTotal < minimumFee) {
                noteText = `Minimum €24 service fee applies`;
            } else {
                noteText = `€${dailyRate}/bag/day × ${bagCount} bag${bagCount > 1 ? 's' : ''} × ${storageDays} day${storageDays > 1 ? 's' : ''}`;
            }
            bookingUrl = '/luggage-storage/';
        }
        
        // Update display
        $calculatedPrice.text(`€${totalPrice}`);
        $priceNote.text(noteText);
        
        // Update booking button
        $bookService.off('click').on('click', function() {
            window.location.href = bookingUrl;
        });
        
        // Add price highlight animation
        $calculatedPrice.addClass('price-update');
        setTimeout(() => {
            $calculatedPrice.removeClass('price-update');
        }, 600);
    }
    
    function toggleStorageFields() {
        if ($serviceType.val() === 'storage') {
            $storageGroup.slideDown(300);
        } else {
            $storageGroup.slideUp(300);
        }
    }
    
    // Event listeners
    $serviceType.on('change', function() {
        toggleStorageFields();
        calculatePrice();
    });
    
    $bagCount.on('input change', calculatePrice);
    $storageDays.on('input change', calculatePrice);
    
    // Initialize
    toggleStorageFields();
    calculatePrice();
    
    console.log('✅ Price Calculator: Initialized');
}

// Progressive enhancement for browsers without JavaScript
document.documentElement.className += ' js-enabled';